import React from "react";

import PropTypes from "prop-types";

import { folderContainer } from "./ChallengesFolder.style";
import FolderContents from "./FolderContents";
import FolderTabsContainer from "./FolderTabsContainer";

const propTypes = {
  subjects: PropTypes.arrayOf(PropTypes.string).isRequired,
  isHomeVersion: PropTypes.bool,
  isTeacher: PropTypes.bool,
  activeData: PropTypes.object,
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.any,
};

const ChallengesFolder = ({
  subjects,
  isHomeVersion = false,
  isTeacher = false,
  activeData,
  activeTab,
  setActiveTab,
}) => {
  if (!subjects || !activeData) return null;
  return (
    <div css={folderContainer}>
      <FolderTabsContainer
        activeTab={activeTab}
        options={subjects}
        setActiveTab={setActiveTab}
      />
      <FolderContents
        activeData={activeData}
        isHomeVersion={isHomeVersion}
        isTeacher={isTeacher}
      />
    </div>
  );
};

ChallengesFolder.propTypes = propTypes;

export default ChallengesFolder;
